import {
    Component,
    Input,
    ChangeDetectorRef,
    SimpleChanges,
    OnChanges,
    Output,
    EventEmitter,
    OnInit
} from '@angular/core';
import {TableViewModel} from '@components/models/table';
import {PaginationService} from './pagination.service';
import {SwitchService} from '@services/switch.service';
import {FormControl, FormGroup} from '@angular/forms';
import {ExcelService} from '@services/excel.service';
import {Pagination} from '../models/Pagination';
import { AppService } from '@services/app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges, OnInit {

    @Input()
    public pagination: Pagination;

    pages: number[] = [];
    count: number = 0;
    currentPage: number = 1;
    exportModal: boolean = false;
    showModalExpor: boolean;
    
    @Input() pageSize: number = 5;
    @Input() title: string = '';
    @Input() isLoadData: boolean = false;
    @Input() model: TableViewModel;
    @Input() isReset: boolean;
    @Input() show_view_import: boolean = false;
    @Input() hideExport: boolean = false;
    @Input() isFile: string = '';

    @Output() clickedPage = new EventEmitter<number>();
    @Output() clickedPageSize = new EventEmitter<number>();
    @Output() changeSearch = new EventEmitter<string>();
    @Output() getTotalRecords = new EventEmitter<any>();
    @Output() editEvent = new EventEmitter<any>();
    @Output() reloadRecords = new EventEmitter<any>();

    searchForm: FormGroup;

    constructor(
        public ref: ChangeDetectorRef,
        public pS: PaginationService,
        private excelService: ExcelService,
        private modalService: SwitchService,
        private appService: AppService,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        this.searchForm = new FormGroup({
            search: new FormControl(null)
        });
        this.pS.$exportModal.subscribe((value) => {
            this.exportModal = value;
        });
        this.modalService.$modalExport.subscribe((value) => {
            this.showModalExpor = value;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isReset'] && this.isReset) {
            setTimeout(() => {
                this.pageSize = 5;
                this.changePageSize(this.pageSize);
                this.initPage();
            });
        }
    }

    reloadTable(){
        this.reloadRecords.emit();
    }
    
    get totalPages() {
        if (!this.pagination) {
            return 0;
        }
        if (this.pagination.rowCount % this.pagination.pageSize == 0) {
            return Math.trunc(
                this.pagination.rowCount / this.pagination.pageSize
            );
        } else {
            return (
                Math.trunc(
                    this.pagination.rowCount / this.pagination.pageSize
                ) + 1
            );
        }
    }

    async loadExcel(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input?.files?.[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        try {

        const fileType = file.name.split('.').pop();

        if (fileType !== 'xlsx' && fileType !== 'xls') {
            this.toastr.error('El archivo no es un archivo Excel válido.');
            return;
        }

        const fileNameWithOutExtension = file.name.split('.').slice(0, -1).join('.');
        const fileName = fileNameWithOutExtension.split('File')[0];
        const modelTest = this.model.description;

        if (fileName !== modelTest) {
            this.toastr.error('El archivo no es el indicado para la carga.');
            return;
        }

        const response_data = await this.appService.formattedData(formData);
        this.getTotalRecords.emit(response_data);
        } catch (error) {
            this.toastr.error('Error al enviar el archivo:', error);
        }
    }

    onPage(page: number) {
        if (page == this.currentPage) return;
        this.count = page - 1;
        this.currentPage = page;
        this.onClick(this.currentPage);
        this.updateVisiblePages();
    }

    next() {
        if (this.count + 1 == this.totalPages) return;
        this.count++;
        this.currentPage++;
        this.onClick(this.currentPage);
        this.updateVisiblePages();
    }

    previous() {
        if (this.count == 0) return;
        this.count--;
        this.currentPage--;
        this.onClick(this.currentPage);
        this.updateVisiblePages();
    }

    initPage() {
        if (this.count == 0) return;
        this.count = 0;
        this.currentPage = 1;
        this.onClick(this.currentPage);
    }

    endPage() {
        if (this.count + 1 == this.totalPages) return;
        this.currentPage = this.totalPages;
        this.count = this.currentPage - 1;
        this.onClick(this.currentPage);
    }

    onClick(pageNumber: number) {
        this.clickedPage.emit(pageNumber);
    }

    changePageSize(pageSize: number) {
        this.clickedPageSize.emit(pageSize);
        this.pageSize = pageSize;
        const totalPages = Math.ceil(this.pagination.rowCount / this.pageSize);
        this.currentPage = Math.min(this.currentPage, totalPages);
        this.count = this.currentPage - 1;
        this.onClick(this.currentPage);
        this.updateVisiblePages();
    }

    updateVisiblePages() {
        this.pages = [];
        const startPage = Math.max(1, this.currentPage - 2);
        const endPage = Math.min(this.totalPages, startPage + 4);
        for (let i = startPage; i <= endPage; i++) {
            this.pages.push(i);
        }
    }

    search(searchby: string) {
        this.changeSearch.emit(searchby);
        this.currentPage = 1;
        this.count = 0;
        this.changeSearch.emit(searchby);
        this.onClick(this.currentPage);
    }

    closeAllModals = () => {
        this.modalService.$modal.emit(false);
        this.show_view_import = false;
    }

    handlingFiles = () => {
        this.modalService.$modal.emit(true);
        this.show_view_import = true;
    }

    onDownloadClick = async () => {
        const fileMap: { [key: string]: string } = {
            responsibles: 'ResponsiblesFile.xlsx',
            contractors: 'ContractorsFile.xlsx',
            routes: 'RoutesFile.xlsx'
        };

        const fileName = fileMap[this.isFile];
        if (!fileName) {
            console.log('No hay archivo para descargar');
            return;
        }

        const link = document.createElement('a');
        link.href = `assets/templates/${fileName}`;
        link.download = fileName;
        link.click();
    };
      
    exportExcel() {
        var data = {
            title: this.model.title,
            header: [],
            data: []
        };
        for (var i = 0; this.model.fields.length > i; i++) {
            var obj = this.model.fields;
            data.header.push(obj[i].title);
        }
        for (var i = 0; this.model.records.length > i; i++) {
            var row = [];
            var record = this.model.records[i];
            for (var i2 = 0; this.model.fields.length > i2; i2++) {
                var field = this.model.fields[i2];
                row.push(record[field.key]);
            }
            data.data.push(row);
        }
        this.excelService.generateExcel(data);
    }

    showModalExport() {
        this.modalService.$modalExport.emit(true);
    }

    async exportAllExcel() {
        var data = {
            title: this.model.title,
            header: [],
            keys: []
        };
        for await (let obj of this.model.fields) {
            data.header.push(obj.title);
            data.keys.push(obj.key);
        }
        this.getTotalRecords.emit(data);
    }
    
}
